module.exports = __webpack_public_path__ + "img/image-016.8bec8bd2.png";